import React, { useEffect, useState } from "react";
import { Grid, Button, Form } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
import axios from "axios";
import { BaseUrlInvoice, BaseUrl } from "../formcomponents/Constants";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import { userData } from "../store/userData";

const TicketList = (props) => {
  const { visaCategoryId } = props;
  const navigate = useNavigate();
  const userDectail = userData();
  const isAdmin = userDectail?.userRole === 1;
  const [excelData, setExcelData] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [ticketTypeList, setTicketTypeList] = useState([]);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchTktNumber, setSearchTktNuumber] = useState("");
  const [searchBySendTo, setSeaqrchBySendto] = useState("")

  useEffect(() => {
    getWorkCatList();
    console.log("userDectail", userDectail.userId);
  }, []);

  useEffect(() => {
    // Only call getVisaList after ticketTypeList has been populated
    if (ticketTypeList.length > 0) {
      getVisaList();
    }
  }, [ticketTypeList]);

  const getWorkCatList = async () => {
    await axios
      .post(BaseUrl + "listSSVisaCategory", {
        ssVisaId: "",
        visaTypeNumber: 45,
      })
      .then((res) => {
        const ticketDataObject = res.data.map((item) => ({
          text: item.visaCategory,
          value: item.visaCategoryId,
        }));

        setTicketTypeList(ticketDataObject);
      })
      .catch((error) => console.log(error));
  };

  const getVisaList = async () => {
    await axios
      .post(BaseUrlInvoice + "accounts/listInventory", {
        userId: userDectail.userId,
        categoryId: visaCategoryId,
        getAll: visaCategoryId === 0 ? true : false,
      })
      .then((res) => {
        setDataForExcel(res.data);
        setRowData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const setDataForExcel = (record) => {
    const tempRecord = record.map(
      ({
        invoiceNo,
        ticketType,
        purchaseDate,
        remarks,
        expiryDate,
        uploadedTotal,
        availableTicket,
      }) => ({
        invoiceNo,
        ticketType: getTicketName(ticketType), // Use getTicketName to map ID to name
        purchaseDate: purchaseDate
          ? new Date(purchaseDate).toLocaleDateString("en-GB")
          : "",
        expiryDate: expiryDate
          ? new Date(expiryDate).toLocaleDateString("en-GB")
          : "",
        uploadedTotal,
        availableTicket,
        remarks,
      })
    );

    setExcelData(tempRecord);
  };

  const getTicketName = (idVal) => {
    const tktName = ticketTypeList.find((item) => item.value === idVal);
    return tktName ? tktName.text : "";
  };

  const filterDataSearch = () => {
    const fromDateObj = new Date(fromDate);
    fromDateObj.setHours(0, 0, 0, 0); // Set time to midnight
    const toDateObj = new Date(toDate);
    toDateObj.setHours(23, 59, 59, 999); // Set time to end of day

    const filteredData = excelData.filter((data) => {
      const dateParts = data.applicationDate.split("/");
      const parsedDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
      parsedDate.setHours(0, 0, 0, 0); // Set time to midnight

      return parsedDate >= fromDateObj && parsedDate <= toDateObj;
    });

    setExcelData(filteredData);
    setRowData(filteredData);
  };

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
    floatingFilter: true,
  };

  const columnDefs = [
    { headerName: "SR Number", field: "invoiceNo", flex: 3 },
    {
      headerName: "Ticket Type",
      field: "ticketType",
      valueGetter: (params) => getTicketName(params.data.ticketType),
      flex: 3,
    },
    { headerName: "Purchase", field: "purchaseDate", flex: 2 },
    { headerName: "Expiry", field: "expiryDate", flex: 2 },
    { headerName: "Uploaded ", field: "uploadedTotal", flex: 1 },
    { headerName: "Available ", field: "availableTicket", flex: 1 },
    { headerName: "Remarks", field: "remarks", flex: 2 },
    {
      headerName: "Edit",
      field: "ssVisaId",
      flex: 1,
      cellRendererFramework: (params) => (
        <Button
          color="primary"
          disabled={!isAdmin}
          onClick={() => isAdmin && updateRecord(params)}
        >
          <AiFillEdit />
        </Button>
      ),
    },
    {
      headerName: "Delete",
      field: "ssInventoryId",
      flex: 1,
      cellRendererFramework: (params) => (
        <Button
          color="red"
          disabled={!isAdmin}
          onClick={() => isAdmin && deleteRecord(params)}
        >
          <AiFillDelete />
        </Button>
      ),
    },
  ];

  const updateRecord = (params) => {
    navigate(`/new-ticket-data/${params.data.ssInventoryId}/${visaCategoryId}`);
  };

  const deleteRecord = (params) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(BaseUrlInvoice + "accounts/deleteInventory", {
            ssInventoryId: params.data.ssInventoryId,
          })
          .then(() => {
            Swal.fire("Deleted!", "Record has been deleted.", "success");
            getVisaList();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };

  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  const searchTicket = async () => {
    await axios
      .post(BaseUrlInvoice + "accounts/searchTicket", {
        ticketNumber: searchTktNumber,
      })
      .then((res) => {
        setDataForExcel(res.data);
        setRowData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const searchSendTo = async () => {
    await axios
      .post(BaseUrlInvoice + "accounts/searchSendTo", {
        sendTo: searchBySendTo,
      })
      .then((res) => {
        setDataForExcel(res.data);
        setRowData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };


  return (
    <div>
      <br />
      <Grid.Row>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            {visaCategoryId != 0 && (
              <Button
                color="primary"
                onClick={() =>
                  navigate(`/new-ticket-data/null/${visaCategoryId}`)
                }
              >
                Create New
              </Button>
            )}

            <Button
              color="primary"
              onClick={(e) => exportToCSV(excelData, "Ticket_List")}
            >
              Export Excel
            </Button>
          </div>
          <div style={{ display: "flex", gap:"20px" }}>

            <div>
            <Form.Input
              name="ticketNumber"
              label="Search By Ticket Number"
              type="text"
              onChange={(e) => setSearchTktNuumber(e.target.value)}
            />
            <Button color="primary" onClick={() => searchTicket()}>
              Search
            </Button>
            </div>
            <div>
            <Form.Input
              name="ticketNumber"
              label="Search By send To"
              type="text"
              onChange={(e) => setSeaqrchBySendto(e.target.value)}
            />
            <Button color="primary" onClick={() => searchSendTo()}>
              Search
            </Button>
            </div>
           
          </div>
        </div>
      </Grid.Row>
      <br />
      <Grid.Row>
        <div className="ag-theme-alpine" style={{ height: 600 }}>
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
          />
        </div>
      </Grid.Row>
    </div>
  );
};

export default TicketList;
